// Karuzela opinii (Figma 2061-450). Bez zależności. Przewijanie o jedną kartę strzałkami lub
// kropkami. Strzałki i kropki pokazują się tylko, gdy jest co przewijać. Serduszka (polubienia)
// obsługuje osobny moduł reviews-likes.js.
function initReviewsCarousel() {
    const root = document.querySelector('[data-reviews-carousel]');
    if (!root) return;

    const track = root.querySelector('[data-reviews-track]');
    const prev = root.querySelector('[data-reviews-prev]');
    const next = root.querySelector('[data-reviews-next]');
    const dotsWrap = root.querySelector('[data-reviews-dots]');
    if (!track) return;

    const cards = () => Array.from(track.querySelectorAll('.s-reviews__card'));

    const step = () => {
        const card = track.querySelector('.s-reviews__card');
        if (!card) return track.clientWidth;
        const gap = parseInt(getComputedStyle(track).columnGap || '48', 10) || 48;
        return card.offsetWidth + gap;
    };

    const maxScroll = () => track.scrollWidth - track.clientWidth;
    // Kilka px zapasu na zaokrąglenia sub-pikselowe — nie traktujemy ich jako „jest co przewijać".
    const isScrollable = () => maxScroll() > 4;

    // Liczba „stron" = liczba przystanków co jedną kartę (np. 5 kart, 3 widoczne → 3 kropki).
    // ceil, bo nawet częściowe wyjście karty poza kadr to dodatkowy przystanek.
    const pageCount = () => {
        if (!isScrollable()) return 1;
        return Math.ceil(maxScroll() / step()) + 1;
    };

    const currentPage = () => {
        const count = pageCount();
        return Math.min(Math.max(Math.round(track.scrollLeft / step()), 0), count - 1);
    };

    let dots = [];

    const buildDots = () => {
        if (!dotsWrap) return;
        const count = pageCount();
        dotsWrap.innerHTML = '';
        dots = [];

        if (count <= 1) {
            dotsWrap.classList.add('is-hidden');
            return;
        }
        dotsWrap.classList.remove('is-hidden');

        for (let i = 0; i < count; i += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 's-reviews__dot';
            dot.setAttribute('aria-label', `Przejdź do opinii ${i + 1}`);
            dot.addEventListener('click', () => {
                track.scrollTo({ left: i * step(), behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
            dots.push(dot);
        }
    };

    const updateArrows = () => {
        const scrollable = isScrollable();
        const atStart = track.scrollLeft <= 0;
        const atEnd = track.scrollLeft >= maxScroll() - 1;
        if (prev) prev.classList.toggle('is-hidden', !scrollable || atStart);
        if (next) next.classList.toggle('is-hidden', !scrollable || atEnd);
    };

    const updateDots = () => {
        if (!dots.length) return;
        const active = currentPage();
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    };

    const refresh = () => {
        buildDots();
        updateArrows();
        updateDots();
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

    track.addEventListener('scroll', () => { updateArrows(); updateDots(); }, { passive: true });
    window.addEventListener('resize', refresh);

    refresh();
}

initReviewsCarousel();
